export default __webpack_public_path__ + "static/media/close_logo.dd79ef18.webp";